import { HttpContext } from "@angular/common/http";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { Observable } from "rxjs";
import { pathParamsHelper } from "../helpers/path-params.helper";
import { DefaultCompetitor } from "../pia-api/generated";
import { PiaCompetitorsService } from "../pia-api/pia-competitors.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";
import { withLoading } from "../utils/with-loading";

export type CompetitorsGroupedByBrandDefined = Record<
  string,
  {
    brand: string;
    items: (DefaultCompetitor & { benchmarkIconId?: string })[];
  }
>;

export type CompetitorsGroupedByBrand =
  | CompetitorsGroupedByBrandDefined
  | null
  | undefined;

export const competitorsResolver: ResolveFn<
  Observable<CompetitorsGroupedByBrand | null>
> = withLoading((route: ActivatedRouteSnapshot) => {
  const piaCompetitorsService = inject(PiaCompetitorsService);
  const { countryID, languageID, year, productDetailID } =
    pathParamsHelper(route);
  const context = new HttpContext().set(IS_IN_RESOLVER_CONTEXT, true);

  return piaCompetitorsService.getComparableCompetitorsGroupedByBrand(
    {
      countryID,
      languageID,
      year,
      productID: productDetailID,
    },
    context,
  );
});
